"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SiteRelease}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseConverter, _DataObjectConverter_);

  function SiteReleaseConverter() {
    _classCallCheck(this, SiteReleaseConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseConverter).apply(this, arguments));
  }

  return SiteReleaseConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseConverter = SiteReleaseConverter;